import  DetectRTC from  'detectrtc';

export   class DetectRTCUtility {



    static  IsWebRTCSupported=()=>{
        return DetectRTC.isWebRTCSupported;
    }

    static  IsMobileDevice=()=>{
        return DetectRTC.isMobileDevice;
    }

    static  IsWebsiteHasMicrophonePermissions=()=>{
        return DetectRTC.isWebsiteHasMicrophonePermissions;
    }

    static  IsWebsiteHasWebcamPermissions=()=>{
        return DetectRTC.isWebsiteHasWebcamPermissions;
    }
    static  OsVersion=()=>{
        return DetectRTC.osVersion;
    }

    static  OsName=()=>{
        return DetectRTC.osName;
    }

    static  IsEdge=()=>{
        return DetectRTC.browser.isEdge;
    }

    static  IsSafari=()=>{
        return DetectRTC.browser.isSafari;
    }
    static  IsIE=()=>{
        return DetectRTC.browser.isIE;
    }

    static  IsOpera=()=>{
        return DetectRTC.browser.isOpera;
    }
    static  IsChrome=()=>{
        return DetectRTC.browser.isChrome;
    }
    static  IsFirefox=()=>{
        return DetectRTC.browser.isFirefox;
    }

}
